import { LegacyRef, useCallback, useState } from 'react';
import { useIntersection } from 'react-use';

const DEFAULT_ROOT_MARGIN = '0px 0px 200px 0px';

export const useHasEnteredViewport = (
    ref: LegacyRef<HTMLDivElement>,
    options?: { visibleInitial: boolean; rootMargin: string },
) => {
    const isVisibleInitial = !!options?.visibleInitial;
    const rootMargin = options?.rootMargin
        ? options?.rootMargin
        : DEFAULT_ROOT_MARGIN;

    const [hasEnteredViewport, setHasEnteredViewport] =
        useState(isVisibleInitial);
    const trackRef = hasEnteredViewport ? { current: null } : ref;

    const intersection = useIntersection(trackRef, {
        rootMargin,
        threshold: 0.01,
    });

    const reset = useCallback(() => {
        setHasEnteredViewport(isVisibleInitial);
    }, [isVisibleInitial]);

    if (
        intersection &&
        intersection.intersectionRatio > 0 &&
        !hasEnteredViewport
    ) {
        setHasEnteredViewport(true);
    }

    return { hasEnteredViewport, reset };
};
